import { PureComponent } from "react";

interface Props {
  id: string;
  className?: string;
  title?: string;
}

export class KibelaSymbol extends PureComponent<Props> {
  render() {
    const symbolName = `ks-${this.props.id}`;
    return (
      <svg className={`ks ${symbolName} ${this.props.className || ""}`} focusable="false">
        {this.props.title && <title>{this.props.title}</title>}
        <use xlinkHref={`#${symbolName}`} />
      </svg>
    );
  }
}
